export default () => ({
    // Field label — semibold per the design spec.
    label: {
        '& .MuiFormControlLabel-label': {
            fontWeight: 600,
        },
    },
});
